import { FCWithChildren } from 'common/types';
import BackButton from 'components/BackButton';

const Wrapper: FCWithChildren = ({ children }) => (
  <>
    <BackButton marginBottom="space-24" />
    {children}
  </>
);

export default Wrapper;
